<template lang="html">
  <div id="notification" class="row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9 notification-page">
      <div class="" style="display: none">
        <img src="../../assets/img/icons/1-bqs-white.svg">
        <img src="../../assets/img/icons/2-vaksina-white.svg">
        <img src="../../assets/img/icons/3-ekto-white.svg">
        <img src="../../assets/img/icons/4-ehino-white.svg">
        <img src="../../assets/img/icons/5-pr-white.svg">
        <img src="../../assets/img/icons/6-izsledwane-white.svg">
        <img src="../../assets/img/icons/7-pristap-white.svg">
        <img src="../../assets/img/icons/8-operaciq-white.svg">
        <img src="../../assets/img/icons/9-legalizaciq-white.svg">
        <img src="../../assets/img/icons/10-drugi-white.svg">
      </div>
      <div class="row">
        <div class="col-sm-12" v-if='userNotifications.length'>
          <div class="row">
            <div class="col-lg-4 col-sm-12 margin-elements" v-for="(notification,idx) in userNotifications">
              <div class="blue-notification" v-if="notification.sendNotification == 1">
                <div>
                  <div v-for="pet in pets" v-if="pet.petId == notification.petId">
                    <div class="thumb" v-if="pet.petThumb">
                      <img class="img-circle img-responsive" v-bind:src="pet.petThumb" :alt="translation.profile.altImage + notification.petName">
                    </div>
                    <div class="thumb" v-else>
                      <img class="img-circle img-responsive" src="../../assets/img/icons/empty-image-no-border.svg" alt="Default Image">
                    </div>
                    <p v-if="notification.petName">{{notification.petName}}</p>
                    <p class="blue"><span>{{notification.validUntil}}</span></p>
                    <p class="blue-notification-text"><span v-for='option in options' v-if="option.value == notification.reviewOptions">
                      <span><img class="img-responsive" :src="option.iconSrcW" :alt="option.text" /></span><span> {{option.text}} </span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="yellow-notification" v-if="notification.sendNotification == 2">
                <div>
                  <div v-for="pet in pets" v-if="pet.petId == notification.petId">
                    <div class="thumb" v-if="pet.petThumb">
                      <img class="img-circle img-responsive" v-bind:src="pet.petThumb" :alt="translation.profile.altImage + pet.petName">
                    </div>
                    <div class="thumb" v-else>
                      <img class="img-circle img-responsive" src="../../assets/img/icons/empty-image-no-border.svg" alt="Default Image">
                    </div>
                    <p v-if="notification.petName">{{notification.petName}}</p>
                    <p class="yellow"><span>{{translation.userNotification.tommorow}}</span></p>
                    <p class="yellow-notification-text"><span v-for='option in options' v-if="option.value == notification.reviewOptions">
                      <span><img class="img-responsive" :src="option.iconSrcW" :alt="option.text" /></span><span> {{option.text}} </span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="green-notification" v-if="notification.sendNotification == 3">
                <div>
                  <div v-for="pet in pets" v-if="pet.petId == notification.petId">
                    <div class="thumb" v-if="pet.petThumb">
                      <img class="img-circle img-responsive" v-bind:src="pet.petThumb" :alt="translation.profile.altImage + pet.petName">
                    </div>
                    <div class="thumb" v-else>
                      <img class="img-circle img-responsive" src="../../assets/img/icons/empty-image-no-border.svg" alt="Default Image">
                    </div>
                    <p v-if="notification.petName">{{notification.petName}}</p>
                    <p class="green"><span>{{translation.userNotification.createReview}}</span></p>
                    <p class="green-notification-text">
                      <span v-for='option in options' v-if="option.value == notification.reviewOptions">
                        <span><img class="img-responsive" :src="option.iconSrcW" :alt="option.text" /></span><span> {{option.text}} </span>
                      </span>
                      <button id="pet-show-btn" class="btn btn-primary green-btn" @click='showPetReviewModal(notification,idx,notification.petName)'>{{translation.button.create}}</button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div ref="pet-modal-user" v-if='modalBolean' class="modal text-left">
            <div class="modal-content" >
              <div class="modal-header">
                <h3>{{translation.modals.petReview + petReview.petName}}</h3>
                <span class="close-modal" @click="hidePetReviewModal">&times;</span>
              </div>
              <div class="modal-body">
                <div class="">
                  <form @submit.prevent="addReview" class="col-sm-12 text-left" novalidate>
                    <select v-model="petReview.reviewOptions" @change="cleareForm" disabled>
                      <option v-for="option in options" :value="option.value">
                        {{option.text}}
                      </option>
                    </select>
                    <div class="row" v-if="petReview.reviewOptions == 'VAR' || petReview.reviewOptions == 'OV'">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <input type="text" name="manufacturer" v-model="petReview.manufacturer" :placeholder="translation.petReview.manufacturer">
                          <label for="manufacturer">{{translation.petReview.manufacturer}}</label>
                        </div>
                        <div class="form-group">
                          <input type="text" name="nameOfVaccine" v-model="petReview.nameOfVaccine" :placeholder="translation.petReview.nameOfVaccine">
                          <label for="nameOfVaccine">{{translation.petReview.nameOfVaccine}}</label>
                        </div>
                        <div class="form-group">
                          <input type="text" name="batchNumber" v-model="petReview.batchNumber" :placeholder="translation.petReview.batchNumber">
                          <label for="batchNumber">{{translation.petReview.batchNumber}}</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate">
                          <label for="vaccinationDate">{{translation.petReview.vaccinationDate}}</label>
                        </div>
                        <div class="form-group">
                          <select v-model="petReview.validUntil">
                            <option v-for="day in days" :value="day.value">
                              {{day.text}}
                            </option>
                          </select>
                          <label for="validUntil">{{translation.petReview.validUntil}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                        </textarea>
                        <label for="comment">{{translation.petReview.comment}}</label>
                      </div>
                    </div>
                    <div class="row" v-if="petReview.reviewOptions == 'TT' || petReview.reviewOptions == 'ET'">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <input type="text" name="manufacturer" v-model="petReview.manufacturer" :placeholder="translation.petReview.manufacturer">
                          <label for="manufacturer">{{translation.petReview.manufacturer}}</label>
                        </div>
                        <div class="form-group">
                          <input type="text" name="nameOfVaccine" v-model="petReview.nameOfVaccine" :placeholder="translation.petReview.nameOfProduct">
                          <label for="nameOfVaccine">{{translation.petReview.nameOfProduct}}</label>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-group">
                          <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate">
                          <label for="vaccinationDate">{{translation.petReview.date}}</label>
                        </div>
                        <div class="form-group">
                          <select v-model="petReview.validUntil">
                            <option v-for="day in days" :value="day.value">
                              {{day.text}}
                            </option>
                          </select>
                          <label for="validUntil">{{translation.petReview.validUntil}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                        </textarea>
                        <label for="comment">{{translation.petReview.comment}}</label>
                      </div>
                    </div>
                    <div class="row" v-if="petReview.reviewOptions == 'anAttack'">
                      <div class="col-sm-6">
                        <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                        </textarea>
                        <label for="comment">{{translation.petReview.comment}}</label>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate">
                          <label for="vaccinationDate">{{translation.petReview.date}}</label>
                        </div>
                        <div class="form-group">
                          <select v-model="petReview.validUntil">
                            <option v-for="day in days" :value="day.value">
                              {{day.text}}
                            </option>
                          </select>
                          <label for="validUntil">{{translation.petReview.validUntil}}</label>
                        </div>
                        <label class="btn btn-success" for="petReviewVideo" accept="video/*" @change="videoMessage">
                            <input id="petReviewVideo" type="file"  style="display:none;">
                            {{translation.button.uploadVideo}}
                        </label>
                        <!-- <div>
                          <progress max="100" :value="uploadPercentage"></progress><span>{{uploadPercentage}} %</span>
                        </div> -->
                        <div class="text-success" v-show="uploadVideoMessage">{{uploadVideoMessage}}</div>
                        <div class="text-danger" v-show="uploadErrorVideoMessage">{{uploadErrorVideoMessage}}</div>
                      </div>
                    </div>
                    <div class="row" v-if="petReview.reviewOptions == 'operation'">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                          </textarea>
                          <label for="comment">{{translation.petReview.options.operation}}</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate">
                          <label for="vaccinationDate">{{translation.petReview.date}}</label>
                        </div>
                        <div class="form-group">
                          <select v-model="petReview.validUntil">
                            <option v-for="day in days" :value="day.value">
                              {{day.text}}
                            </option>
                          </select>
                          <label for="validUntil">{{translation.petReview.validUntil}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="petReview.reviewOptions == 'legalisation'">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                          </textarea>
                          <label for="comment">{{translation.petReview.date}}</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate">
                          <label for="vaccinationDate">{{translation.petReview.date}}</label>
                        </div>
                        <div class="form-group">
                          <select v-model="petReview.validUntil">
                            <option v-for="day in days" :value="day.value">
                              {{day.text}}
                            </option>
                          </select>
                          <label for="validUntil">{{translation.petReview.validUntil}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="petReview.reviewOptions == 'Others'">
                    <div class="row" v-if="petReview.reviewOptions == 'PR'">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                          <label for="vaccinationDate">{{translation.petReview.date}}</label>
                        </div>
                      </div>
                      <div class="col-md-6">

                      </div>
                      <div class="col-md-12">
                        <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                        </textarea>
                        <label for="comment">{{translation.petReview.comment}}</label>
                      </div>
                    </div>
                    <div class="row" v-if="petReview.reviewOptions == 'IZ'">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input type="text" name="otherTheme" v-model="petReview.otherTheme" :placeholder="translation.petReview.izText">
                          <label for="otherTheme">{{translation.contact.theme}}</label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                          <label for="vaccinationDate">{{translation.petReview.date}}</label>
                        </div>
                        <div class="form-group">
                          <select name="validUntil" v-model="petReview.validUntil">
                            <option v-for="day in days" :value="day.value">
                              {{day.text}}
                            </option>
                          </select>
                          <label for="validUntil">{{translation.petReview.validUntil}}</label>
                        </div>
                      </div>
                      <div class="col-md-12 pet-image-modal">
                        <div class="form-group">
                          <p>{{translation.petReview.imageFromIz}}:</p>
                          <label class="btn add-doctor-image" for="add-pet-review-image" accept="image/*" @change=''>
                              <input id="add-pet-review-image" type="file"  style="display:none;">
                              {{translation.button.addImage}}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                        </textarea>
                        <label for="comment">{{translation.petReview.comment}}</label>
                      </div>
                    </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <textarea name="comment" rows="4" v-model="petReview.comment" :placeholder="translation.petReview.comment">
                          </textarea>
                          <label for="comment">{{translation.petReview.comment}}</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <input type="date" name="vaccinationDate" v-model="petReview.vaccinationDate" :placeholder="translation.petReview.date">
                          <label for="vaccinationDate">{{translation.petReview.date}}</label>
                        </div>
                        <div class="form-group">
                          <select v-model="petReview.validUntil">
                            <option v-for="day in days" :value="day.value">
                              {{day.text}}
                            </option>
                          </select>
                          <label for="validUntil">{{translation.petReview.validUntil}}</label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="modal-footer">
                <button class="modal-button-remove close-modal-button" @click='hidePetReviewModal'>{{translation.button.remove}}</button>
                <button type="submit" size="sm" class="float-right modal-button-add" @click="addReview">{{translation.button.create}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12" v-else>
          <h3>{{translation.userNotification.noNotification}}</h3>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from '../../components/Footer.vue'
export default {
  name: 'Notifications',
  data(){
    return {
      transition: message,
      userNotifications: [],
      loader: false,
      pets: [],
      options: message.petReview.options,
      days: message.petReview.days,
      modalBolean: false,
      noResult: false,
      isSelected: null,
      petReview:[]
    }
  },
  components: {
    Footer
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    window.pageHeader = this.translation.header.notifications;
    this.getDayNotification();
    this.getPets();
    this.$bus.$on('logged', () => {
      this.getPets();
    });
    window.headerPage = this.translation.header.notifications;
  },
  methods: {
    getPets: function(){
      this.loader = true;
      var self = this;
      axios.get('get-pets')
      .then(function (response){
          self.loader = false;
          self.pets = response.data.result
      })
      .catch(err => console.error(err))
    },
    getDayNotification(){
      this.loader = true;
      var self = this;
      axios.get('get-day-notifications')
      .then(function(response){
        self.loader = false;
        if (self.userNotifications = response.data) {
          self.userNotifications = response.data.result;
        }
        else {
          self.userNotifications = [];
        }
      })
      .catch(err => err)
    },
    approveNotification(reviewId, notif){
      this.loader = true;
      var formData = this.toFormData({petReviewId: reviewId, notification: notif});
      var self = this;
      axios.post('update-day-notification', formData)
      .then(function(response){
        self.loader = false;
        self.getDayNotification();
      })
      .catch(err => err)
    },
    addReview(){
      this.loader = true;
      var startDate = (new Date(this.petReview.vaccinationDate)).getTime();
      var afterDay = this.petReview.validUntil * 24*60*60*1000;
      var finalDate = new Date(startDate + afterDay);
      this.petReview.validUntil = finalDate.toISOString().slice(0,10);
      var video = document.getElementById('petReviewVideo');
      var formData = this.toFormData(this.petReview);
      var self = this;
      const reader = new FileReader();
      if (video != undefined && video != null) {
        video = document.getElementById('petReviewVideo').files[0];
        if (video.name.match(/.(m4v|avi|mpg|mp4|webm)$/i)) {
          formData.append('videos[]', video)
          formData.append('createFolder', 'videos')
        }else{
          self.uploadErrorVideoMessage = self.translation.errors.videoError;
        }
      }else {
        formData.append('createFolder', '')
      }
      axios.post('add-pet-review', formData)
      .then(function(response){
        self.loader = false;
        self.petReview = {
          userId: '',
          reviewOptions: 'VAR',
          manufacturer: '',
          nameOfVaccine: '',
          batchNumber: '',
          vaccinationDate: new Date().toISOString().slice(0,10),
          validUntil: '0',
          comment: ''
        }
        self.hidePetReviewModal();
      })
      .catch(err => err)
      this.approveNotification(this.petReview.petReviewId,0);
    },
    showPetReviewModal(data,idx,petName) {
      this.modalBolean = true;
      this.petReview = data;
      this.petReview.petName = petName;
      this.petReview.vaccinationDate = new Date().toISOString().slice(0,10);
      this.petReview.validUntil = '0';
    },
    hidePetReviewModal() {
      this.petReview = {
        reviewOptions: 'VAR',
        manufacturer: '',
        nameOfVaccine: '',
        batchNumber: '',
        vaccinationDate: new Date().toISOString().slice(0,10),
        validUntil: '0',
        comment: ''
      }
      this.modalBolean = false;
    },
    cleareForm(){
        this.petReview.manufacturer = '';
        this.petReview.nameOfVaccine = '';
        this.petReview.batchNumber = '';
        this.petReview.vaccinationDate = new Date().toISOString().slice(0,10);
        this.petReview.validUntil = '0';
        this.petReview.comment = '';
        this.uploadPercentage = 0;
        this.uploadVideoMessage = '';
        this.uploadErrorVideoMessage = '';
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    }
  }
}
</script>

<style lang="css" scoped>
#notification {

  background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  max-height: 100%;

  background-position: center;
  background-size: cover;
  min-height: 100vh;
}
#notification .footer{
  color: #707070;
  margin-top: 20em;
}
#notification .notification-page{
  margin-top: 7em;
}
#notification .col-sm-4{
  margin-top: 1em;
}
#notification .blue-notification{
  border: 2px solid #3057B0;
  border-radius: 1em;
  background: #FFF;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-radius: 1.2em
}
#notification .blue-notification div{
  margin-top: 1em;
  color: #707070;
}
#notification .blue-notification .pet-image{
  margin-right: 1em;
}
#notification .blue-notification .blue-notification-text{
  background: #3057B0;
  color: #fff;
  padding: 1em;
  margin-bottom: 0;
  border-bottom-left-radius: 1em;
  border-bottom-right-radius: 1em;
}
#notification .yellow-notification{
  border: 2px solid #FED154;;
  border-radius: 1em;
  background: #FFF;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-radius: 1.2em
}
#notification .thumb img{
  height: 10em;
  width: 10em;
}
#notification span img{
  max-width: 3em;
}
#notification .yellow-notification div{
  margin-top: 1em;
  color: #707070;
}
#notification .yellow-notification .pet-image{
  margin-right: 1em;
}
#notification .yellow-notification .yellow-notification-text{
  background: #FED154;
  color: #fff;
  padding: 1em;
  margin-bottom: 0;
  border-bottom-left-radius: 1em;
  border-bottom-right-radius: 1em;
}
#notification .green-notification{
  border: 2px solid #84AE53;
  border-radius: 1em;
  background: #FFF;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-radius: 1.2em
}
#notification .green-notification div{
  margin-top: 1em;
  color: #707070;
}
#notification .margin-elements{
  margin-top: 2em;
}
#notification .green-notification .pet-image{
  margin-right: 1em;
}
#notification .green-notification .green-notification-text{
  background: #84AE53;
  color: #fff;
  padding: 1em;
  margin-bottom: 0;
  border-bottom-left-radius: 1em;
  border-bottom-right-radius: 1em;
}
#notification h3 {
   color: #3057B0;
   margin-top: 3em;
}
#notification .green-btn{
    background: #fff;
    border: 1px solid #3057B0;
    color: #84AE53;
    padding-left: 1em;
    padding-right: 1em;
    border: none;
    outline: none;
    border-radius: 5em;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .form-group{
    position: relative;
    margin-top: 2em;
  }
   #notification input[type=text],
   #notification input[type=password],
   #notification input[type=email],
   #notification textarea,
  #notification input[type=date],
  #notification  select
  {
   color: #707070!important;
   background: none!important;
   border: none!important;
   border-radius: 0!important;
   outline: none!important;
   border-bottom: 2px solid #707070!important;
   width: 100%;
   outline: none!important;
   margin-bottom: 2em;
   font-weight: bold;
 }
  label {
   display: none;
 }
  #notification input[type=text]:focus,
  #notification input[type=password]:focus,
  #notification input[type=email]:focus,
  #notification textarea:focus,
  #notification input[type=date]:focus,
  #notification select:focus
 {
   border-bottom: 2px solid #3057B0!important;
   outline:0px !important;
   -webkit-appearance:none;
   box-shadow: none !important;
   opacity: 1;
   color: #3057B0!important;
 }
  #notification input[type=text]:focus + label ,
  #notification input[type=password]:focus + label,
  #notification input[type=email]:focus + label,
  #notification textarea:focus + label,
  #notification input[type=date]:focus + label,
  #notification select:focus + label
 {
    display: block;
    position: absolute;
    bottom: 3.5em;
    color: #707070!important;
    font-size: 1em;
    opacity: 1;
 }
 #notification textarea:focus + label{
   bottom: -.5em;
 }
  #notification input[type=text]:focus::-webkit-input-placeholder,
  #notification input[type=password]:focus::-webkit-input-placeholder,
  #notification input[type=email]:focus::-webkit-input-placeholder
 {
   color:transparent;
 }
  #notification input[type=text]::-moz-placeholder
  #notification input[type=password]:focus::-moz-placeholder
  #notification input[type=email]:focus::-moz-placeholder {
   color:transparent;
 }
  #notification input[type=text]:focus::-moz-placeholder
  #notification input[type=password]:focus::-moz-placeholder
  #notification input[type=email]:focus::-moz-placeholder {
    color:transparent;
  }
   #notification input[type=text]:focus::-ms-input-placeholder
   #notification input[type=password]:focus::-ms-input-placeholder
   #notification input[type=email]:focus::-ms-input-placeholder {
   color:transparent;
 }
 #notification ::placeholder {
   color: #707070!important;
   opacity: 1;
 }
 #notification :-ms-input-placeholder {
   color: #707070!important;
 }
 #notification ::-ms-input-placeholder {
   color: #707070!important;
 }
</style>
